<template>
  <div class="page">
    <div class="guest-bind-container">
      <div class="page-title">Guest Bind</div>
      <div class="page-info-list" v-if="roleList.length">
        <div class="role-item" v-for="item in roleList" :key="item.userid || item.id">
          <div class="role-main">
            <div class="account">Tài khoản：{{ item.username }}</div>
            <div class="server">Server：{{ item.roles.server_name }}</div>
            <div class="role-name">Nhân vật：{{ item.roles.cp_role_name }}</div>
            <div class="role-name">Cấp：{{ item.roles.cp_role_name }}</div>
            <div class="role-name">Trạng thái nạp：{{ item.roles.cp_role_name }}</div>
          </div>
          <el-button class="bind-button" type="primary" size="small" @click="openBind(item)">Bind</el-button>
        </div>
      </div>
      <div v-else class="empty">No guest role found</div>
    </div>
    <bind-email :visible.sync="dialogVisible" :role="selectedRole" :mock-mode="mockMode" />
  </div>
</template>
<script>
import BindEmail from "./components/bindEmail.vue";
export default {
  name: "GuestBind",
  components: { BindEmail },
  data() { return { mockMode: true, roleList: [], selectedRole: null, dialogVisible: false }; },
  created() { this.getRoleList(); },
  methods: {
    getRoleList() {
      if (this.mockMode) {
        this.roleList = this.normalizeRoleList([
          {
            "userid": "8695613",
            "username": "3D77A5F0348F544FA142367D48B5BF5C",
            "roles": {
              "role_id": "9773336",
              "server_id": "3440",
              "cp_roleid": "zz210z0o11w",
              "cp_role_name": "Nghệ Nhân",
              "server_name": "VN-1"
            }
          },
          {
            "userid": "8778373",
            "username": "F84060AA6985A1D84FF32B0E9ACD8698",
            "roles": {
              "role_id": "9876124",
              "server_id": "3440",
              "cp_roleid": "zz22ate8xn0",
              "cp_role_name": "Nghệ Nhân",
              "server_name": "VN-1"
            }
          },
          {
            "userid": "9028519",
            "username": "E53127B48A28008DDE9B99B30A134EE4",
            "roles": {
              "role_id": "10201478",
              "server_id": "3595",
              "cp_roleid": "zz03mkwsegw",
              "cp_role_name": "Nghệ Nhân",
              "server_name": "VN-32"
            }
          }
        ]);
        return;
      }
      const params = { game_id: this.$route.query.game_id || this.$store.state.gameData.game_id };
      this.$http.get("/center/guestBindList", { params }).then((res) => {
        if (res.data.code === 200) this.roleList = res.data.data || [];
        else this.$message.error(res.data.msg || "Failed to load role list");
      });
    },
    normalizeRoleList(list) {
      return list.map((item) => ({
        ...item,
        role_id: item.roles && item.roles.role_id,
        server_id: item.roles && item.roles.server_id,
        cp_roleid: item.roles && item.roles.cp_roleid,
        server_name: item.roles && item.roles.server_name,
        role_name: item.roles && item.roles.cp_role_name,
      }));
    },
    openBind(item) { this.selectedRole = item; this.dialogVisible = true; },
  },
};
</script>
<style scoped lang="scss">
.page {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  background: #f5f7fa;
}

.guest-bind-container {
  width: 33.333vw;
  min-width: 420px;
  max-width: 560px;
  height: 100vh;
  box-sizing: border-box;
  padding: 30px 0;
  display: flex;
  flex-direction: column;
}

.page-info-list {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.page-title {
  padding: 0 20px 20px;
  color: #303133;
  font-size: 22px;
  font-weight: 600;
  text-align: center;
}

.role-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 74px;
  box-sizing: border-box;
  padding: 15px 18px;
  margin-bottom: 12px;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.role-main {
  min-width: 0;
  flex: 1;
}

.account {
  color: #303133;
  font-size: 16px;
  font-weight: bolder;
  line-height: 20px;
  overflow-wrap: anywhere;
  word-break: break-all;
}

.bind-button {
  flex-shrink: 0;
  margin-left: 12px;
}

.server {
  margin-top: 4px;
  color: #606266;
}

.role-name {
  margin-top: 5px;
  color: #909399;
  font-size: 16px;
}

.empty {
  padding: 20px;
  color: #909399;
  text-align: center;
}

@media screen and (max-width: 1024px) {
  .guest-bind-container {
    width: 90%;
    min-width: 0;
  }
}

@media screen and (max-width: 480px) {
  .guest-bind-container {
    width: calc(100% - 30px);
    padding: 20px 0;
  }

  .account {
    max-width: 100%;
  }
}
</style>
